/**
 * Returns a callback to switch between different elements
 * based on selected value.
 * @param {Element} component
 * @returns {Function} A callback function
 */
const handleSwitch = (component) => () => {
    $(component).find('[data-switch-id]').show();
    const $inputs = $(component).find('.select input');
    if ($inputs.is(':checked')) {
        $(component).find('.select input').each(function() {
            if ($(this).is(':not(:checked)')) {
                $(component).find(`[data-switch-id="${$(this).val()}"]`).hide();
            } else {
                $(component).find(`[data-switch-id="${$(this).val()}"]`).show();
            }
        });
    }
};

export default handleSwitch;



// WEBPACK FOOTER //
// ./src/scripts/components/switcher/handleSwitch.js